import { memo, useRef } from 'react'
import { without } from 'lodash-es'
import { IconX } from '@tabler/icons'

const getCache = (userData) => {
  const result = {}
  userData.forEach((user) => {
    result[user.id] = user
  })

  return result
}

const UserTags = ({ value, userData, onChange }) => {
  const cache = useRef()

  if (!cache.current && userData) {
    cache.current = getCache(userData)
  }

  const remove = (v) => {
    onChange(without(value, v))
  }

  if (!cache.current) return null

  return (
    <div className="flex gap-2 overflow-auto py-1">
      {value.map((v) => (
        <div
          className="flex items-center gap-1 bg-gray-200 rounded px-2 py-1"
          key={v}
        >
          <span className="text-sm whitespace-nowrap">
            {cache.current[v]?.name}
          </span>
          <IconX
            className="cursor-pointer"
            size={14}
            onClick={() => remove(v)}
          />
        </div>
      ))}
    </div>
  )
}

export default memo(UserTags)
